import { useEffect } from "react";
import QuoteForm from "./QuoteForm";

export default function QuoteModal() {
  const handleOverlayClick = (e) => {
    if (e.target.id === "quoteModal") closeModal();
  };

  const closeModal = () => {
    if (typeof window !== "undefined" && window.$) {
      window.$("#quoteModal").removeClass("active");
      window.$("#quoteModal").removeClass("show"); // Account for both possible classes
      window.$("body").css("overflow", "");
    }
  };

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") closeModal(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="quote-modal-overlay" id="quoteModal" onClick={handleOverlayClick}>
      <div className="quote-modal" style={{ maxWidth: "680px" }}>
        <div className="quote-modal-header">
          <h3><i className="fas fa-file-alt"></i> Get A Quote</h3>
          <button className="quote-modal-close" aria-label="Close" onClick={closeModal}>&times;</button>
        </div>

        <div className="quote-modal-body">
          <QuoteForm onCloseModal={closeModal} />
        </div>
      </div>
    </div>
  );
}
